import { connect } from "react-redux";

import { getAdvertisement } from "./actions";
import Component from "./advertisement";
import {
  makeSelectAdvertisement,
  makeSelectIsError,
  makeSelectIsReady,
} from "./reducer";

const makeMapStateToProps = () => {
  const selectAdvertisement = makeSelectAdvertisement();
  const selectIsReady = makeSelectIsReady();
  const selectIsError = makeSelectIsError();
  const mapStateToProps = (state, ownProps) => ({
    isReady: selectIsReady(state, ownProps),
    isError: selectIsError(state, ownProps),
    advertisement: selectAdvertisement(state, ownProps),
  });

  return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
  onGetAdvertisement: (data) => dispatch(getAdvertisement(data)),
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
